import { Link } from "react-router-dom";
import { activeUsers, topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function ActiveBoard() {
  const max = Math.max(...activeUsers.map((u) => u.score));
  const latest = topics.slice(2, 6);

  return (
    <section className="px-4 md:px-10 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-3">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-6">最新上桌的讨论</h2>
          <div className="flex flex-col gap-3">
            {latest.map((t) => (
              <TopicCard key={t.id} topic={t} layout="horizontal" />
            ))}
          </div>
          <Link
            to="/topics"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            看更多新话题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <aside className="lg:col-span-2">
          <div className="rounded-lg bg-secondary-950 text-secondary-100 p-6">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-trophy-line"></i>
              </span>
              <h2 className="font-heading font-bold text-lg text-background-50">本周活跃网友</h2>
            </div>
            <ul className="space-y-5">
              {activeUsers.map((u, i) => (
                <li key={u.name}>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-100 text-sm">
                      {u.name.slice(0, 1)}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-background-50 flex items-center gap-1.5">
                        {u.name}
                        {i === 0 && <i className="ri-vip-crown-line text-accent-300 text-xs"></i>}
                      </p>
                      <p className="text-xs text-secondary-300">{u.title}</p>
                    </div>
                    <span className="text-xs text-accent-300 font-medium whitespace-nowrap">{u.score}</span>
                  </div>
                  <div className="h-1.5 rounded-full bg-secondary-800 overflow-hidden">
                    <div className="h-full rounded-full bg-accent-500" style={{ width: `${Math.round((u.score / max) * 100)}%` }}></div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}